import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import VolunteerSolicitorContext from "./volunteer-solicitor-context";

export const useVolunteerSolicitorResolver = ({ poolId, contactIds }) => {
  const { fetchSolicitorsIfNotCached } = React.useContext(VolunteerSolicitorContext);
  const prev_contact_ids = React.useRef([]);
  const prev_pool_id = React.useRef(null);

  React.useEffect(() => {
    if (!_.difference(contactIds, prev_contact_ids.current).length && poolId === prev_pool_id.current) {
      return;
    }
    if (contactIds.length && poolId) {
      fetchSolicitorsIfNotCached(poolId, contactIds);
    }
  });

  // since need to do deeper check of contactIds, safe off prev ones to manually diff
  React.useEffect(() => {
    prev_contact_ids.current = contactIds;
    prev_pool_id.current = poolId;
  });
};

export const VolunteerSolicitorResolver = props => {
  useVolunteerSolicitorResolver({ poolId: props.poolId, contactIds: props.contactIds });

  const { solicitors, fetchSolicitors } = React.useContext(VolunteerSolicitorContext);
  const renderProp = typeof props.render === "function" ? props.render : props.children;
  return renderProp({ solicitors, fetchSolicitors });
};

export const useVolunteerSolicitorForContactAndPool = ({ contactId, poolId }) => {
  const { solicitors } = React.useContext(VolunteerSolicitorContext);
  const solicitor = Object.values(solicitors).find(sol => sol.contact_id === contactId && sol.pool_id === poolId) || {};
  return solicitor;
};

useVolunteerSolicitorForContactAndPool.propTypes = {
  poolId: PropTypes.number.isRequired,
  contactId: PropTypes.number.isRequired,
};

export default VolunteerSolicitorResolver;
